
import ProductTile from './M04-ProductTile/ProductTile.vue'
import FilterPager from '../M02-ShopFilter/components/FilterPager/FilterPager.vue'
import ShopFilter from '../M02-ShopFilter/ShopFilter.vue'
import SortDropdown from './SortDropdown/SortDropdown.vue'
import verifyLabel from '../../../methods/verifyLabel'

export default {
    name: 'product-tile-grid',
    data(){
        return {
            searchConfig : {
                skip: 0,
                take: 1,
                puid: '22ae6b81-0a19-4d91-ade0-79b86f870ecb',
                language: "da"
            },
        }
    },
    computed:{
        productCards() {
            if (this.$store.state.search.results) {
                return this.$store.state.search.results
            }
        },
        hasError() {
            return this.$store.state.search.hasError
        },
        hasStaleWarning() {
            return this.$store.state.search.hasStaleWarning
        },
        errorMessage() {
            return this.verifyLabel("filterSearchErrorMessage")
        },
        retryLabel() {
            return this.verifyLabel("filterSearchErrorRetryLabel")
        },
        staleWarningMessage() {
            return this.verifyLabel("filterSearchStaleWarning")
        }
    },
    methods: {
        retry() {
            this.$store.dispatch('search/performSearch')
        },
        verifyLabel(key) {
            if (this.$store.state.main.labels) {
                return verifyLabel(key, this.$store.state.main.labels)
            }
            return ""
        }
    },
    components: {
        ProductTile,
        FilterPager,
        SortDropdown,
        ShopFilter
    }
}